module.exports = __webpack_public_path__ + "static/Go-08f64309d22b6f9ba423430af84bc8d8.svg";